import { render, staticRenderFns } from "./PokemonLevelBadge.vue?vue&type=template&id=ca558a8e&scoped=true"
import script from "./PokemonLevelBadge.vue?vue&type=script&lang=js"
export * from "./PokemonLevelBadge.vue?vue&type=script&lang=js"
import style0 from "./PokemonLevelBadge.vue?vue&type=style&index=0&id=ca558a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca558a8e",
  null
  
)

export default component.exports